import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, X, Gamepad2 } from 'lucide-react';
import LanguageSelector from './LanguageSelector';

const Header = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-lg shadow-sm border-b border-gray-100' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <Gamepad2 className="w-5 h-5 text-white" />
            </div>
            <span className="font-display text-lg md:text-xl font-semibold text-gray-900">
              {t('brand')}
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-gray-600 hover:text-primary-600 transition-colors text-sm font-medium">
              {t('nav.features')}
            </a>
            <a href="#how-it-works" className="text-gray-600 hover:text-primary-600 transition-colors text-sm font-medium">
              {t('nav.howItWorks')}
            </a>
          </nav>

          {/* Right side */}
          <div className="flex items-center gap-3">
            <LanguageSelector />
            
            <a 
              href="/start" 
              className="hidden md:inline-flex btn-primary px-5 py-2.5 rounded-lg font-semibold text-sm"
            >
              {t('nav.getStarted')}
            </a>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-gray-700"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <nav className="flex flex-col p-4 gap-1">
            <a 
              href="#features" 
              className="text-gray-600 hover:text-primary-600 hover:bg-gray-50 transition-colors py-3 px-4 rounded-lg"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t('nav.features')}
            </a>
            <a 
              href="#how-it-works" 
              className="text-gray-600 hover:text-primary-600 hover:bg-gray-50 transition-colors py-3 px-4 rounded-lg"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t('nav.howItWorks')}
            </a>
            <a 
              href="/start" 
              className="btn-primary px-5 py-3 rounded-lg font-semibold text-center mt-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t('nav.getStarted')}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
